var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"container px-4 py-4 mx-auto mb-2 text-sm max-w-7xl sm:px-6 lg:px-8"},[_vm._v(" Copyright "+_vm._s(_vm.year)+" The Post Office ")])}
var staticRenderFns = []

export { render, staticRenderFns }